<template>
  <a :href="model.TargetUrl" class="widget">
    <div class="widget__title">{{ $res.Views.HomePage_Widget_WaitingForPayment }}</div>
    <div class="widget__body">
      <div class="widget__count"
           :class="{ 'widget__count_small': model.Count > 99 }">
        {{ model.Count }}
      </div>
      <div class="widget__content">
        <div class="widget__content-inner">
          <div>{{ $tc("bookingTextOnly", model.Count)}}</div>
          <div class="widget__bottom-content" v-if="model.LastPaymentDayBookingCount > 0">
            <span class="widget__await24h">{{ model.LastPaymentDayBookingCount }} {{ $res.Views.HomePage_Widget_LessThan24Hours }}</span>
          </div>
        </div>
        <div class="widget__icon">
          <svg width="36" height="36" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.2 4.5H1.2444C1.33398 4.15773 1.60282 3.87372 1.9703 3.7821L12.1584 1.24192C12.6943 1.10831 13.237 1.43441 13.3706 1.97029L14.089 4.85146C13.8565 4.63348 13.5438 4.5 13.2 4.5Z" fill="currentColor"/>
            <path d="M14.5 9.91824V6.49999L15.0641 8.76236C15.1834 9.24097 14.936 9.72505 14.5 9.91824Z" fill="currentColor"/>
            <path d="M1 6.5C1 5.94772 1.44772 5.5 2 5.5H12.5C13.0523 5.5 13.5 5.94772 13.5 6.5V8H1V6.5Z" fill="currentColor"/>
            <path d="M1 9H13.5V13.5C13.5 14.0523 13.0523 14.5 12.5 14.5H2C1.44772 14.5 1 14.0523 1 13.5V9Z" fill="currentColor"/>
          </svg>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    model: Object,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@use "./widget";


.widget__bottom-content {
  margin-top: 3px;
  position: relative;
}

.widget__await24h {
  background-color: var(--system-30);
  color: var(--second-10);
  padding: 2px 8px;
  border-radius: var(--border-radius-sm);    
}
</style>


